import { resolveQuickReplyContent } from './quickReplyVariables';

const PLACEHOLDER_PATTERN = /\{\{\s*([a-z_]+)\s*\}\}/gi;

export function findUnresolvedQuickReplyPlaceholders(content) {
    if (!content) {
        return [];
    }

    const matches = [...String(content).matchAll(PLACEHOLDER_PATTERN)];
    const labels = matches.map((match) => `{{${match[1]}}}`);

    return [...new Set(labels)];
}

export function hasUnresolvedQuickReplyPlaceholders(content) {
    return findUnresolvedQuickReplyPlaceholders(content).length > 0;
}

export function createEmptyQuickReplyComposeState() {
    return { draft: null, modified: false };
}

/**
 * Build final HTML for submit: re-resolve from template when unchanged,
 * otherwise resolve any remaining placeholders in the editor HTML.
 */
export function prepareQuickReplyComposeContent({
    editorHtml,
    quickReplyCompose = createEmptyQuickReplyComposeState(),
    ticket,
    user,
}) {
    const { draft, modified } = quickReplyCompose ?? createEmptyQuickReplyComposeState();

    let content;
    if (draft?.template && !modified) {
        content = resolveQuickReplyContent(draft.template, { ticket, user });
    } else {
        content = resolveQuickReplyContent(editorHtml ?? '', { ticket, user });
    }

    const unresolved = findUnresolvedQuickReplyPlaceholders(content);

    return { content, unresolved };
}

export function formatUnresolvedQuickReplyMessage(unresolved = []) {
    if (!unresolved.length) {
        return '';
    }

    return `Unresolved variables: ${unresolved.join(', ')}. Fix or remove them before sending.`;
}
